import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { AccountModal, Spinner } from '../../components'

const PasswordRecoveryModal = ({
    isVisible,
    onCloseModal,
    handleSubmit,
    onSubmit,
    message,
    loading
}) => (
    <AccountModal isVisible={isVisible} onCloseModal={onCloseModal}>
        <p className="forgot-password-modal-title">ESQUECI MINHA SENHA</p>
        { message &&
            <div className={`callout ${message.type}`} data-closable>
                <p className="callout-message">{message.message}</p>
            </div>
        }
        <form onSubmit={handleSubmit(onSubmit)}>
            <Field component="input" className="account-modal-input" required name="email" placeholder="E-mail" type="email" />
            <button className="account-button" type="submit">Enviar</button>
        </form>
        <Spinner isLoading={ loading } />
    </AccountModal>
);

export default reduxForm({ form: 'passwordRecoveryForm' })(PasswordRecoveryModal);
